<div class="animated container-fluid">
    <form class="needs-validation" [formGroup]="form" novalidate>
        
        <h4>
            Editar Ámbito {{ambitoPeriodo?.IdCampaniaDescripcion}} - {{ambitoPeriodo?.DescripcionPeriodo}}
        </h4>

        <div class="row">
            <div class="col-md-12">

                <div class="row">

                    <div class="col-md-12">
                        <div class="card card-accent-success animated fadeIn">
                            <a class="card-header-a" (click)="isCollapsedCabecera = !isCollapsedCabecera" [attr.aria-expanded]="!isCollapsedCabecera" aria-controls="collapseExample">
                                <div class="card-header-buscador">
                                    <i class="fa fa-file-text-o"></i> Ámbito
                                    <i *ngIf="isCollapsedCabecera" class="fa fa-caret-down float-right"></i>
                                    <i *ngIf="!isCollapsedCabecera" class="fa fa-caret-up float-right"></i>
                                </div>
                            </a>
                            <div class="card-body-detalle">
                                <div class="collapse group-filtros" id="collapsedCabecera" [ngbCollapse]="isCollapsedCabecera">

                                    <div class="row">
                                        <div class="form-group col-md-3">
                                            <label class="col-form-label" for="inpActiva">Ámbito Nacional</label>
                                            <p-toggleButton class="form-control-togglebutton" formControlName="AmbitoNacional" onLabel="Sí" offLabel="NO" onIcon="pi pi-check"
                                                            (onChange)="onSelectAmbito()" offIcon="pi pi-times"></p-toggleButton>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <!--COMUNIDADES-->
                    <div class="col-md-6">

                        <div class="card card-accent-success animated fadeIn">

                            <div class="card-header-buscador">
                                <i class="fa fa-plus"></i> <strong id="">Comunidades Autónomas</strong>
                                <label class="col-form-label" [ngClass]="{ 'required-field' : campoObligatorio }" for=""></label>
                            </div>
                            <div class="card-body-detalle-list">

                                <div class="row">
                                    <div class="col-md-12">

                                        <div class="form-group">
                                            <div class="input-group">

                                                <ng-select class="ngselect-listbox"
                                                           [items]="comunidades"
                                                           bindLabel="Descripcion"
                                                           bindValue="Id"
                                                           formControlName="IdCA"
                                                           loadingText="Cargando..."
                                                           [loading]="(!comunidades || comunidades.length === 0)"
                                                           notFoundText="Comunidad Autónoma no encontrada"
                                                           placeholder="-- Seleccione una Comunidad Autónoma --"
                                                           clearAllText="Eliminar selección"
                                                           (change)="onSelectComunidadAutonoma()"
                                                           [ngClass]="displayFieldCssNgSelect('IdCA')">
                                                </ng-select>

                                                <span *ngIf="!esPeriodoFinalizado" class="input-group-btn">
                                                    &nbsp;<button name="btnAddComunidad" [disabled]="!campoObligatorio || !form.value.IdCA" class="btn btn-list btn-secondary btn-listbox"
                                                                  type="button" title="Añade una Comunidad" (click)="onAddComunidad()">
                                                        <i class="fa fa-plus"></i>
                                                    </button>
                                                </span>

                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="row">

                                    <div class="col-md-12" *ngIf="ambitoPeriodo">

                                        <label class="cabeceraTablaDetalles">Comunidades Autónomas</label>
                                        <table class="table table-list table-sm">
                                            <!-- table-responsive -->
                                            <tbody>
                                                <tr *ngFor="let item of ambitoPeriodo.TPeriodoAmbitoCaCamCollection">
                                                    <td scope="col">
                                                        <div class="btn-group min-width">
                                                            &nbsp;<button *ngIf="showButtonDeleteComunidad(item)" (click)="onDeleteComunidad(item)" type="button" title="Eliminar comunidad"
                                                                    class="btn btn-sm btn-danger btn-listbox">
                                                                <i class="fa fa-remove"></i>
                                                            </button>
                                                        </div>
                                                    </td>

                                                    <td scope="col" class="td-list">{{item.DescripcionComunidad}}</td>
                                                </tr>

                                            </tbody>
                                        </table>

                                        <div class="invalid-feedback-collectionlist d-block" *ngIf="isFieldInvalidNoSubmit('IdCA','required')">
                                            * Debe especificar una comunidad.
                                        </div>

                                    </div>
                                </div>

                            </div>
                        </div>

                    </div>
                    <!--PROVINCIAS-->
                    <div class="col-md-6">

                        <div class="card card-accent-success animated fadeIn">

                            <div class="card-header-buscador">
                                <i class="fa fa-plus"></i> <strong id="">Provincias</strong>
                                <label class="col-form-label" [ngClass]="{ 'required-field' : campoObligatorio }" for=""></label>
                            </div>
                            <div class="card-body-detalle-list">

                                <div class="row">
                                    <div class="col-md-12">

                                        <div class="form-group">
                                            <div class="input-group">

                                                <ng-select class="ngselect-listbox"
                                                           [items]="provincias"
                                                           [readonly]="!provincias"
                                                           bindLabel="Descripcion"
                                                           bindValue="Id"
                                                           formControlName="IdProvincia"
                                                           loadingText="Cargando..."
                                                           [loading]="((!provincias || provincias.length === 0) && (form.value.IdCA !== null && form.value.IdCA !== undefined))"
                                                           notFoundText="Provincia no encontrada"
                                                           placeholder="-- Seleccione una Provincia --"
                                                           clearAllText="Eliminar selección"
                                                           [ngClass]="displayFieldCssNgSelect('IdProvincia')">
                                                </ng-select>

                                                <span *ngIf="!esPeriodoFinalizado" class="input-group-btn">
                                                    <button name="btnAddProvincia" [disabled]="!campoObligatorio || !form.value.IdProvincia" class="btn btn-list btn-secondary btn-listbox"
                                                                  type="button" title="Añade una Provincia" (click)="onAddProvincia()">
                                                        <i class="fa fa-plus"></i>
                                                    </button>
                                                </span>

                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="row">

                                    <div class="col-md-12" *ngIf="ambitoPeriodo">

                                        <label class="cabeceraTablaDetalles">Provincias</label>
                                        <table class="table table-list table-sm">
                                            <!-- table-responsive -->
                                            <tbody>
                                                <tr *ngFor="let item of ambitoPeriodo.TPeriodoAmbitoProvinciaCamCollection">
                                                    <td scope="col">
                                                        <div class="btn-group min-width">
                                                            &nbsp;<button *ngIf="showButtonDeleteProvincia(item)" (click)="onDeleteProvincia(item)" type="button" title="Eliminar provincia"
                                                                    class="btn btn-sm btn-danger btn-listbox">
                                                                <i class="fa fa-remove"></i>
                                                            </button>
                                                        </div>
                                                    </td>

                                                    <td scope="col" class="td-list">{{item.DescripcionProvincia}}</td>
                                                </tr>

                                            </tbody>
                                        </table>

                                        <div class="invalid-feedback-collectionlist d-block" *ngIf="isFieldInvalidNoSubmit('IdProvincia','required')">
                                            * Debe especificar una provincia.
                                        </div>

                                    </div>
                                </div>

                            </div>
                        </div>

                    </div>

                </div>

            </div>
        </div>
    </form>
</div>
